<header class="o-minimal-header -primary select-none">
  <nav
    #sideNavigation
    *ngIf="
      !currentNavigationItemService.currentNavigationItem.hideSideNavigation
    "
    [class.-open]="sideNavigationService.isSideNavOpen()"
    [ngClass]="{ hidden: finderFilterService.filterOpened }"
    aria-hidden="false"
    aria-label="Side Navigation"
    class="m-side-navigation -contrast"
  >
    <div class="m-side-navigation__header">


      <div class="flex">

        @if (sideNavigationService.isSideNavOpen()) {
          <img
            src="assets/NG_Portal_Icon.svg"
            alt="NG Portal Icon"
            class="ng-portal-icon"
            width="50"
            height="50"
          />
        }

        <div class="m-side-navigation__header__label -size-l highlight">
          NG Portal
        </div>
      </div>

      <button
        (click)="toggleSideNav()"
        aria-haspopup="false"
        aria-label="Open Side Navigation"
        class="a-button a-button--integrated -without-label m-side-navigation__header__trigger -open"
        tabindex="0"
        type="button"
      >
        <i
          class="a-icon a-button__icon boschicon-bosch-ic-list-view-mobile"
          title="Open Side Navigation"
        ></i>
      </button>
      <button
        (click)="toggleSideNav()"
        aria-haspopup="false"
        aria-label="Close Side Navigation"
        class="a-button a-button--integrated -without-label m-side-navigation__header__trigger -close"
        tabindex="-1"
        type="button"
      >
        <i
          class="a-icon a-button__icon boschicon-bosch-ic-close"
          title="Close Side Navigation"
        ></i>
      </button>
    </div>
    <div class="sidemenu-wrapper">
      <div>
        <ul class="m-side-navigation__menuItems" role="menubar">
          <side-navigation-item
            *ngFor="let navigationItem of navigationItems.getSideNavItems()"
            [name]="navigationItem.name"
            [navigationItem]="navigationItem"
          >
          </side-navigation-item>
          <side-navigation-item
            [name]="userService.getUser().displayName"
            [navigationItem]="navigationItems.getProfilePage()"
          >
          </side-navigation-item>
        </ul>
      </div>
    </div>
  </nav>

  <div #supergraphic class="o-minimal-header__supergraphic"></div>

  <div #headerTop class="o-minimal-header__top">
    <div
      *ngIf="
        !currentNavigationItemService.currentNavigationItem.hideSideNavigation
      "
      class="o-minimal-header__burger"
    >
      <button
        (click)="toggleSideNav()"
        aria-label="Side Navigation"
        class="a-button a-button--integrated -without-label"
        type="button"
      >
        <i class="a-icon a-button__icon ui-ic-menu" title="Side Navigation"></i>
      </button>
    </div>
    <div
      [ngClass]="{ 'title-container': sideNavigationService.isSideNavOpen() }"
      class="o-minimal-header__title"
    >
      {{ currentNavigationItemService.currentNavigationItem.name }}
    </div>
    <ul class="o-minimal-header__actions">
      <li>
        <ide-client/>
      </li>
      <li class="w-[300px]">
        @if (currentNavigationOnStartPage()) {
          <start-page-search-bar [isMinimal]="false"/>
        }
      </li>
    </ul>
    <a
      [routerLink]="navigationItems.getStartPage().routerLink"
      aria-label="Bosch Logo"
      class="o-minimal-header__logo"
    >
      <svg
        height="24px"
        viewBox="0 0 108 24"
        width="108px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M78.19916,15.03735c0,3.46057-3.1618,5.1535-6.12445,5.1535c-3.41083,0-5.17847-1.29462-6.57263-2.96265 l2.51453-2.48962c1.07056,1.36926,2.46472,2.0415,4.0083,2.0415c1.29462,0,2.14105-0.62244,2.14105-1.56848 c0-0.99585-0.77179-1.31952-2.83813-1.74274l-0.54773-0.12451c-2.48962-0.52283-4.53113-1.91699-4.53113-4.75519 c0-3.112,2.53943-4.97925,5.87549-4.97925c2.8382,0,4.65564,1.21991,5.77594,2.48962l-2.46472,2.43988 c-0.82831-0.91748-2.00061-1.44946-3.23651-1.46893c-0.89624,0-1.91699,0.42328-1.91699,1.46893 c0,0.97095,1.07056,1.31946,2.41492,1.59332l0.54773,0.12451C75.51038,10.73029,78.24896,11.42737,78.19916,15.03735z  M64.80499,11.92529c0,4.65558-2.66394,8.29047-7.26971,8.29047c-4.58093,0-7.26971-3.63489-7.26971-8.29047 c0-4.63068,2.68878-8.29047,7.26971-8.29047C62.14105,3.63483,64.80499,7.29462,64.80499,11.92529z M60.92114,11.92529 c0-2.46472-1.1452-4.48132-3.38586-4.48132s-3.36102,1.9917-3.36102,4.48132s1.12036,4.50623,3.36102,4.50623 S60.92114,14.43982,60.92114,11.92529z M87.06226,16.43152c-1.74274,0-3.56018-1.44397-3.56018-4.60583 c0-2.81323,1.69293-4.38171,3.46057-4.38171c1.39423,0,2.21576,0.64728,2.8631,1.76764l3.18671-2.11621 c-1.59338-2.41492-3.48547-3.43567-6.09961-3.43567c-4.78009,0-7.36926,3.70953-7.36926,8.19086 c0,4.70544,2.86304,8.39008,7.31946,8.39008c3.13696,0,4.63074-1.09546,6.24902-3.43567l-3.21167-2.16602 C89.25311,15.68463,88.55603,16.43152,87.06226,16.43152z M48.97095,15.46057c0,2.66388-2.43982,4.40662-4.92944,4.40662H35.9502 V4.0332h7.44397c2.8382,0,4.9046,1.44397,4.9046,4.35681c0.01666,1.43036-0.85675,2.72058-2.19086,3.23651 C46.10791,11.65143,48.97095,12.29877,48.97095,15.46057z M39.80914,10.25726h2.83813 c0.02155,0.00134,0.04309,0.00226,0.06464,0.00269c0.81476,0.01575,1.48804-0.6319,1.50385-1.44666 c0.00342-0.0567,0.00342-0.11353,0-0.17017c-0.047-0.77802-0.71576-1.37061-1.49377-1.32361h-2.88794L39.80914,10.25726z  M44.76349,14.98755c0-0.92114-0.67218-1.54358-2.09131-1.54358h-2.81323v3.11206h2.88794 C43.91699,16.55603,44.76349,16.13275,44.76349,14.98755z M103.64313,4.03326v5.82568H98.8382V4.03326h-4.15771v15.83398h4.15771 v-6.24896h4.80493v6.24896h4.15771V4.03326H103.64313z"
          id="bosch-logo-text"
        />
        <path
          d="M12,0C5.37256,0,0,5.37256,0,12c0,6.62738,5.37256,12,12,12s12-5.37262,12-12C23.99646,5.37402,18.62598,0.00354,12,0z  M12,22.87964C5.99133,22.87964,1.12036,18.00867,1.12036,12S5.99133,1.1203,12,1.1203S22.87964,5.99133,22.87964,12 C22.87354,18.0061,18.0061,22.87354,12,22.87964z M19.50293,7.05475c-0.66852-1.01306-1.53552-1.88-2.54858-2.54852h-0.82159 v4.10785H7.89209V4.50623H7.04565c-4.13873,2.73114-5.27972,8.30029-2.54858,12.43896 c0.66852,1.01306,1.53552,1.88007,2.54858,2.54858h0.84644v-4.10791h8.24066v4.10791h0.82159 C21.09308,16.76257,22.23407,11.19348,19.50293,7.05475z M6.74689,17.87549c-3.24493-2.88354-3.5379-7.85168-0.65436-11.09668 c0.20508-0.23077,0.42358-0.44928,0.65436-0.65436V17.87549z M16.13275,14.24066H7.89209V9.73444h8.24066V14.24066z  M17.84827,17.25549c-0.18768,0.2088-0.38629,0.40747-0.59515,0.59509v-2.48962V8.61407V6.12445 C20.49121,9.03387,20.75763,14.0174,17.84827,17.25549z"
          id="bosch-logo-anker"
        />
      </svg>
    </a>
    <div class="o-minimal-header__falafel">
      @if (currentNavigationOnStartPage()) {
        <start-page-search-bar [isMinimal]="true"/>
      }
    </div>
  </div>
</header>
